export default "__VITE_ASSET__2ZQykjpx__"